<!-- Responsibility: Render the lobby cover art used on sign-in and onboarding surfaces.
Scope: Image presentation only; launch and routing logic live in the owning screen. -->
<lobby-cover-art class="lobby-cover-art" aria-hidden="true">
  <div class="cover-strip">
    <img src="/assets/onboarding/img1.png" alt="" loading="eager" decoding="async">
    <img src="/assets/onboarding/img2.png" alt="" loading="eager" decoding="async">
    <img src="/assets/onboarding/img3.png" alt="" loading="eager" decoding="async">
    <img src="/assets/onboarding/img4.png" alt="" loading="eager" decoding="async">
  </div>

  <style>
    lobby-cover-art {
      display: block;
      width: 100%;
      background: var(--bg);
    }

    lobby-cover-art .cover-strip {
      display: grid;
      grid-template-columns: repeat(4, minmax(0, 1fr));
      gap: 1px;
      min-height: 16rem;
      background: color-mix(in srgb, var(--border) 24%, transparent);
    }

    lobby-cover-art img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
      filter: saturate(0.88) brightness(0.76);
    }

    @media (max-width: 47.5rem) {
      lobby-cover-art .cover-strip {
        grid-template-columns: repeat(2, minmax(0, 1fr));
        min-height: 18rem;
      }
    }

    @media (max-width: 28rem) {
      lobby-cover-art .cover-strip {
        grid-template-columns: 1fr;
        min-height: 20rem;
      }
    }
  </style>
</lobby-cover-art>
